export default function () {
  return {
    elapsed: 0,
    paused: true,
  };
}
